import { CalendarDays, History, MessageCircle, Sun, UserRound, Wallet } from 'lucide-react';
import { lazy, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { RouteObject } from 'react-router';
import { PortalShell, useUnreadMessages, type NavItem } from '@/components/shell';

const TodayPage = lazy(() => import('./pages/TodayPage'));
const CalendarPage = lazy(() => import('./pages/CalendarPage'));
const HistoryPage = lazy(() => import('./pages/HistoryPage'));
const PayrollPage = lazy(() => import('./pages/PayrollPage'));
const MessagesPage = lazy(() => import('./pages/MessagesPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const JobDetailPage = lazy(() => import('./pages/JobDetailPage'));

function EmployeeLayout() {
  const { t } = useTranslation('employee');
  const unread = useUnreadMessages();
  const nav: NavItem[] = [
    { to: '/employe', label: t('nav.today'), icon: Sun, end: true, primary: true },
    { to: '/employe/calendrier', label: t('nav.calendar'), icon: CalendarDays, primary: true },
    { to: '/employe/historique', label: t('nav.history'), icon: History },
    { to: '/employe/paie', label: t('nav.payroll'), icon: Wallet, primary: true },
    { to: '/employe/messages', label: t('nav.messages'), icon: MessageCircle, badge: unread, primary: true },
    { to: '/employe/profil', label: t('nav.profile'), icon: UserRound },
  ];
  return <PortalShell nav={nav} title={t('nav.title')} homeTo="/employe" />;
}

/** Employee portal routes (mounted under /employe). Deliberately minimal. */
const employeeRoutes: { element: ReactElement; children: RouteObject[] } = {
  element: <EmployeeLayout />,
  children: [
    { index: true, element: <TodayPage /> },
    { path: 'calendrier', element: <CalendarPage /> },
    { path: 'historique', element: <HistoryPage /> },
    { path: 'paie', element: <PayrollPage /> },
    { path: 'messages', element: <MessagesPage /> },
    { path: 'messages/:id', element: <MessagesPage /> },
    { path: 'profil', element: <ProfilePage /> },
    { path: 'menages/:id', element: <JobDetailPage /> },
  ],
};
export default employeeRoutes;
